import { useArrowNavigationGroup } from '@fluentui/react-components';
export const useChatMoverAttribute_unstable = ()=>useArrowNavigationGroup({
        axis: 'vertical',
        memorizeCurrent: true,
        unstable_hasDefault: true
    });

//# sourceMappingURL=useChatMoverAttribute.js.map